import { connectMenu } from 'instantsearch.js/es/connectors';

// create the render function
const renderMenuSelect = (renderOptions) => {
    const {
        instantSearchInstance,
        items,
        refine,
        widgetParams,
    } = renderOptions;

    if (items.length > 0) {
        const isRefined = items.filter((item) => item.isRefined);

        widgetParams.container.innerHTML = `
            <select class="md:hidden max-w-96 [text-align-last:center]">
                <option value="">All Categories</option>
                ${items.map((item) => `
                    <option value="${item.value}"${item.isRefined ? ' selected' : ''}>${item.label}</option>
                `).join('')}
            </select>
            <span
                class="max-md:hidden py-3.5 px-4 border-2 text-xs font-semibold tracking-wider uppercase whitespace-nowrap transition-colors hover:bg-black hover:border-black hover:text-white ${isRefined.length === 0 ? ' border-orange bg-orange text-white' : ' border-tbc-grey'}"
                tabindex="0"
                role="button"
                data-value="all">All</span>
            ${items.map((item) => `
                <span
                    class="max-md:hidden py-3.5 px-4 border-2 text-xs font-semibold tracking-wider uppercase whitespace-nowrap transition-colors hover:bg-black hover:border-black hover:text-white ${item.isRefined ? ' border-orange bg-orange text-white' : ' border-tbc-grey'}"
                    tabindex="0"
                    role="button"
                    data-value="${item.value}">${item.label}</span>
            `).join('')}
        `;

        [...widgetParams.container.querySelectorAll('span')].forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();

                if (event.currentTarget.dataset.value === 'all') {
                    instantSearchInstance
                        .helper
                        .clearRefinements(widgetParams.attribute)
                        .search();
                    return;
                }

                refine(event.currentTarget.dataset.value);
            });
        });

        const select = widgetParams.container.querySelector('select');
        select.addEventListener('change', (event) => {
            event.preventDefault();
            refine(select.value);
        });
    } else {
        widgetParams.container.innerHTML = '<p>No options available for the current filter.</p>';
    }
};

// create the custom widget
const customMenuSelect = connectMenu(renderMenuSelect);

export default customMenuSelect;
